// src/components/PublicRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

function PublicRoute() {
  const { user, trabajador, franquiciado } = useAuthStore(state => ({
    user: state.user,
    trabajador: state.trabajador,
    franquiciado: state.franquiciado,
  }));

  const location = useLocation();

  // Páginas que pueden ser accedidas incluso estando logueado
  const allowedPathsWhenLoggedIn = [
    '/features',
    '/about',
    '/documentation',
    '/terminos',
    '/privacy',
    '/legal',
    '/politica-de-cookies',
    '/pricing',
    '/blog',
    '/blog/',
    '/payment-result',
    '/reset-password',
    '/change-password',
    '/franquiciado/reset-password',
    '/franquiciado/change-password'
  ];

  // Verificar si la ruta actual está permitida para usuarios logueados
  const isAllowedPath = allowedPathsWhenLoggedIn.some(path => location.pathname.startsWith(path));

  // Si está logueado pero intenta acceder a una página permitida, permitir acceso
  if ((user || trabajador || franquiciado) && isAllowedPath) {
    return <Outlet />;
  }

  // Si está logueado y no es una página permitida, redirigir al dashboard correspondiente
  // Prioridad: franquiciado > trabajador > user
  if (franquiciado) {
    const franquiciadoId = franquiciado._id || franquiciado.franquiciadoId;
    if (franquiciadoId && !isAllowedPath) {
      return <Navigate to={`/franquiciado/${franquiciadoId}/dashboard`} replace />;
    }
  } else if (trabajador) {
    const trabajadorId = trabajador._id || trabajador.trabajadorId;
    if (trabajadorId && !isAllowedPath) {
      return <Navigate to={`/trabajador/${trabajadorId}/dashboard`} replace />;
    }
  } else if (user) {
    if (!isAllowedPath) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <Outlet />;
}

export default PublicRoute;
